import * as types from './types';

export const getMoreVacanciesList = (queryParams) => ({
    type: types.CANDIDATE_MORE_VACANCIES_GET_LIST,
    queryParams
});

export const setMoreVacanciesList = (vacancies) => ({
    type: types.CANDIDATE_MORE_VACANCIES_SET_LIST,
    vacancies
})
export const setMoreVacanciesListLoading  = (isLoading) => ({
    type: types.CANDIDATE_MORE_VACANCIES_SET_LIST_LOADING,
    isLoading
});
export const resetMoreVacanciesList = () => ({
    type: types.CANDIDATE_MORE_VACANCIES_SET_LIST_RESET
})


// WEBPACK FOOTER //
// ./src/actions/candidate/candidate-more-vacancies/index.js